import './assets/scss/main.scss';
import Vue from 'vue';
import VueAnalytics from 'vue-analytics';
import VueGtm from 'vue-gtm';
import KlickpagesHeader from '@klicksitemfa/saas-pages-klickpages-header';
import KlickpagesSupportChat from '@klicksite/klickpages-support-chat';
import i18n from './i18n';
import { store, router } from './config';
import App from './App';
import rebrandConfigs from './config/rebrand';

const VueApp = new Vue({
  store,
  i18n,
  router,
  rebrandConfigs,
  render: h => h(App),
});

Vue.use(KlickpagesHeader, { store });
Vue.use(KlickpagesSupportChat, { store });

Vue.use(VueAnalytics, {
  id: process.env.ANALYTICS_ID.split(','),
  router,
  autoTracking: {
    page: process.env.NODE_ENV === 'production' || process.env.NODE_ENV === 'staging',
  },
});

Vue.use(VueGtm, {
  id: process.env.GTM_API_KEY.split(','),
  defer: false,
  enabled: true,
  loadScript: true,
  vueRouter: router,
});

VueAnalytics.onScriptLoaded().then(() => {
  VueApp.$mount('#app');
});



/** WEBPACK FOOTER **
 ** ./src/main.js
 **/